const endpoint="https://data.laposte.fr/data-fair/api/v1/datasets/laposte-hexasmal/lines";
const cache=new Map();
export async function lookupPostalCities(code,{signal}={}) {
 const postal=String(code||"").trim();
 if(!/^\d{5}$/.test(postal))return [];
 const cached=cache.get(postal);
 if(cached && Date.now()-cached.at<86400000)return [...cached.cities];
 const params=new URLSearchParams({qs:`code_postal:"${postal}"`,select:"code_postal,nom_de_la_commune,code_commune_insee",size:"1000"});
 const response=await fetch(`${endpoint}?${params}`,{signal});
 if(!response.ok)throw new Error("Référentiel postal indisponible");
 const data=await response.json();
 if(!Array.isArray(data.results) || Number(data.total)>data.results.length)throw new Error("Réponse du référentiel postal incomplète");
 const cities=[...new Set(data.results.filter(row=>String(row.code_postal)===postal).map(row=>String(row.nom_de_la_commune||"").trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,"fr"));
 if(cache.size>=500)cache.delete(cache.keys().next().value);
 cache.set(postal,{at:Date.now(),cities});
 return cities;
}
